import { hasText } from 'shared/lib/common-util'
import { PreviousDocument } from '../common/types'
import { RuleResult } from '../../../types/DeclarationP5'

const NA60Validator = {
  validatePreviousDocumentDocumentTypeRequirement: (previousDocument?: PreviousDocument): RuleResult => (hasText(previousDocument?.procedureType) ? 'NOT_ALLOWED' : 'OPTIONAL'),
  validatePreviousDocumentProcedureTypeRequirement: (previousDocument?: PreviousDocument): RuleResult => (hasText(previousDocument?.documentType) ? 'NOT_ALLOWED' : 'OPTIONAL'),
} as const

export default NA60Validator
